import {
    STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_FAILURE,
    STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_SUCCESS
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_BEGIN:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_SUCCESS:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
            isFastStockLoading:false,
            fastStockLoading: {
              saveData: { files: [] },
              brandOptions: [],
              modelOptions: [],
              yearOptions: [],
              versionOptions: [],
              carLotsOptions: [],
              branchOfficeDefault: null,
              stateOptions: [],
              savedForm: false,
              galeryImagesRowUp: [], 
              galeryImagesRowDown: [],
              pendingFileImage: false,
              errorImagesExpertise: null,
              errorSelectFileImage: null,
              errorDeleteFileImage: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAST_STOCK_LOADING_FAILURE:
        return {
          takingCarManagement: {
            ...state.takingCarManagement,
          }
        }
      default:
        return state
    }
  }
  